/**
 * Upscale API
 * Endpoint: POST /api/upscale/single
 */
import apiClient, { createAuthConfig, isMockApi } from "../client";
import { appendLineageToForm } from "./studio_features";
import { appendAiImage } from "./aiUpload";

const MULTIPART = (token) => ({
  ...createAuthConfig(token),
  timeout: 300000,
  headers: {
    ...createAuthConfig(token).headers,
    "Content-Type": "multipart/form-data",
  },
});

/**
 * Upscale a single image.
 * @param {string} token - Clerk session token
 * @param {File|null} file - Image file (use null when sending image_url)
 * @param {object} [opts]
 * @param {string} [opts.image_url]
 * @param {string} [opts.quality='balanced'] - fast | balanced | best
 * @param {string} [opts.scale] - e.g. "2", "4", "2x", "4x"
 * @param {boolean} [opts.cleanup_jpeg]
 * @param {boolean} [opts.polish]
 * @param {string} [opts.output_format='png']
 * @returns {Promise<{success: boolean, output_url?: string, credits_used?: number, remaining_credits?: number, creation_id?: string, message?: string}>}
 */
export async function upscaleSingle(token, file, opts = {}) {
  if (isMockApi) {
    const mockSrc = opts.image_url || (file ? URL.createObjectURL(file) : "");
    return {
      success: true,
      output_url: mockSrc || "",
      credits_used: 1,
      remaining_credits: 99,
    };
  }

  const form = new FormData();
  await appendAiImage(form, file, {
    imageUrl: opts.image_url,
    requiredMessage: "upscaleSingle: provide file or opts.image_url",
  });
  if (opts.quality) form.append("quality", opts.quality);
  if (opts.scale) form.append("scale", opts.scale);
  if (opts.cleanup_jpeg != null) form.append("cleanup_jpeg", String(opts.cleanup_jpeg));
  if (opts.polish != null) form.append("polish", String(opts.polish));
  if (opts.output_format) form.append("output_format", opts.output_format);
  appendLineageToForm(form, opts.lineage);

  const response = await apiClient.post(
    "/api/upscale/single",
    form,
    MULTIPART(token)
  );
  return response.data;
}

export default {
  upscaleSingle,
};
